export const agnieszkaGuminska = {
    'mydrId': 'agnieszkagumińska',
    'firstName': 'Agnieszka',
    'lastName': 'Gumińska',
    'profession': 'Psycholog dziecięcy',
    'avatar': 'agnieszka-guminska.webp',
    'slug': 'psycholog-dzieciecy-agnieszka-guminska',
    'locations': ['torun'],
    'services': [
        ['psychology', 'consultation'],
        ['psychoterapy', 'parents']
    ]
}